import { useQuery } from '@tanstack/react-query';
import { ContactEmailThreadResponse } from '../../types/ContactEmails';
import { libApiInstance } from '../axios';

export function useEmail(contactId: number, messageId: number) {
    return useQuery({
        queryKey: [`contact-${contactId}`, 'email', messageId],
        queryFn: async ({ signal }): Promise<ContactEmailThreadResponse> => {
            const result = await libApiInstance.get(
                `/contacts/${contactId}/emailthread/${messageId}`,
                { signal },
            );
            return result.data as ContactEmailThreadResponse;
        },
    });
}
